import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { useContext, useState } from "react";
import { ForgotPass, Login } from "../../../../services/LoginService";
import LoginModel from "../../../../models/Login";
import { AuthenticationContext } from "../../../controls/auth/AuthenticationWrap";

export default function useForgot(props: {
	setOpenDialog?: (value: boolean) => void;
	setLoading?: (value: boolean) => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const [errorMess, setErrorMess] = useState("");
	// const backPath = getBackPath(search);
	const authCtx = useContext(AuthenticationContext);
	const doForgot = async (email: string) => {
		try {
			await ForgotPass(email);

			openAlertDialog?.(AlertType.Success, "Please check your email", () => {
				props.setLoading?.(false);
				props.setOpenDialog?.(false);
			});
		} catch (error: any) {
			openAlertDialog?.(AlertType.Fail, error?.response.data?.message || "An error has occurred!", () => {
				props.setLoading?.(false);
			});
			setErrorMess(error?.response.data?.message || "An error has occurred!");
		} finally {
		}
	};

	return {
		doForgot,
		errorMess,
	};
}
